import { getSignalingSocket } from 'services/signaling';
import {
  ContentLibraryFileUploadAcceptedPayload,
  ContentLibraryType,
} from 'features/content-library/types';

interface RequestLibraryFileUploadParams {
  activeLibraryType: ContentLibraryType;
  fileName: string;
  folderId: string;
  fileSize: number;
}

export const requestLibraryFileUpload = (
  params: RequestLibraryFileUploadParams
): Promise<ContentLibraryFileUploadAcceptedPayload> =>
  getSignalingSocket().sendAsync<ContentLibraryFileUploadAcceptedPayload>({
    event: 'requestLibraryFileUpload',
    data: {
      personal: params.activeLibraryType === 'personal',
      name: params.fileName,
      folderId: params.folderId === 'root' ? null : params.folderId,
      fileSize: params.fileSize,
    },
  });
